var map = {
	"./screen1.jpg": 16,
	"./screen2.jpg": 17,
	"./screen3.jpg": 18,
	"./screen4.jpg": 19,
	"./screen5.jpg": 20,
	"./screen6.jpg": 21,
	"./screen7.jpg": 22,
	"./screen8.jpg": 23,
	"./screen9.jpg": 24
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15;